import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
	root: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: 9999 // Adjust the z-index if needed
	},
	progress: {
		margin: theme.spacing(2)
	}
}));

const Wip = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center'
				}}
			>
				<CircularProgress className={classes.progress} color="primary" />
				<Typography variant="h6">Work in Progress...</Typography>
			</div>
		</div>
	);
};

export default Wip;
